import request from '@/utils/request'

export function getContract(query) {
    console.log("get_contract",typeof(query))
    // console.log("get_question", query)
    if(typeof(query)=="number"){
        return request({
            url: '/api/contract_manager_record/' + query,
            method: 'get',
        })
    }
    else{
        return request({
            url: '/api/contract_manager_record/' + query,
            method: 'get',
        })
    }
}
export function insert_update_contract(data) {
  // console.log(data);
    return request({
        url: '/api/contract_manager_record',
        method: 'post',
        data
    })
}